module.exports = '<svg width="39" height="32" viewBox="0 0 39 32"><path d="M0 13.538v16A2.46 2.46 0 0 0 2.462 32h34.462a2.46 2.46 0 0 0 2.462-2.462v-16c0-.679-.551-1.231-1.231-1.231H1.232c-.679 0-1.231.551-1.231 1.231zm32 9.847c0 .679-.551 1.231-1.231 1.231h-7.385a1.231 1.231 0 0 1-1.231-1.231v-2.462c0-.679.551-1.231 1.231-1.231h7.385c.679 0 1.231.551 1.231 1.231v2.462zm7.385-17.231V2.462A2.46 2.46 0 0 0 36.923 0H2.461A2.46 2.46 0 0 0-.001 2.462v3.692c0 .679.551 1.231 1.231 1.231h36.923c.679 0 1.231-.551 1.231-1.231z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/credit-card-1.js
// module id = 1093
// module chunks = 14